import { useAuth0 } from '@auth0/auth0-react';
import { useTranslation } from 'react-i18next';
import loginConfig from 'auth/loginConfig';
import signUpConfig from 'auth/signUpConfig';
import styles from './HeroSection.module.less';
import heroOmni from 'assets/img/omnione_getstarted_hero.png';

export default function HeroSection() {
	const { loginWithRedirect, user } = useAuth0();
	const { t } = useTranslation();
	return (
		<>
			<div className={styles.heroSectionBackground}>
				<div className={styles.heroSectionContainer}>
					<div className={styles.heroSectionTextCol}>
						<div className={styles.heroSectionTextWrapper}>
							<h1 className={styles.heroSectionHeader}>Welcome to Omni Dev</h1>
							<p className={styles.heroSectionSubHeader}>
								This portal gives game developers access to the tools and resources needed to bring their titles to the Omni One
								platform.
							</p>
							{!user && <p className={styles.heroSectionSubHeader}>Are you developing for the Omni One Store or Meta Store?</p>}
							<div className={styles.heroSectionBtns}>
								{!user && (
									<>
										<div onClick={() => loginWithRedirect(loginConfig)}>
											<div className={styles.heroSectionBtn}>Omni One Store</div>
										</div>
										<div onClick={() => (window.location.href = 'https://quest-developers.virtuix.com')}>
											<div className={styles.heroSectionBtn}>Meta Store</div>
										</div>
									</>
								)}
							</div>
							{!user && (
								<>
									<p className={styles.heroSectionSubHeader}>
										Having trouble accessing the portal? Please contact your Virtuix representative.
									</p>
								</>
							)}
						</div>
					</div>
					<div className={styles.heroSectionImageCol}>
						<div className={styles.heroSectionImageWrapper}>
							<img src={heroOmni} alt="Omni One" className={styles.heroSectionImage} />
						</div>
					</div>
				</div>
			</div>
			<div className={styles.heroSectionImageResponsive}></div>
		</>
	);
}
